// extracted by mini-css-extract-plugin
export var body = "Y_c";
export var footer = "Y_cb";
export var footerText = "Y_cc";
export var section = "Y_d";
export var title = "Y_h";